import MethodsListsBlock from './MethodsListsBlock';

export default MethodsListsBlock;